import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export type RecoveryAiActivityState = {
  hideResolved: boolean
}

// The Escalations table's "hide resolved" toggle. Feature-level state, so it
// lives here rather than useState — the Redux store (unlike a URL query
// param) survives every in-SPA navigation, including the static
// `to="/recovery_ai/escalations"` Link on the case-detail "Back to
// Escalations" link, which doesn't carry any query string.
const initialState: RecoveryAiActivityState = {
  hideResolved: true,
}

const slice = createSlice({
  name: 'recoveryAiActivity',
  initialState,
  reducers: {
    hideResolvedChanged: (state, action: PayloadAction<boolean>) => {
      state.hideResolved = action.payload
    },
  },
})

export const { hideResolvedChanged } = slice.actions
export const reducer = slice.reducer

export const selectHideResolved = (state: {
  recoveryAiActivity?: RecoveryAiActivityState
}) => state.recoveryAiActivity?.hideResolved ?? true
